@if (data && tableName && displayedColumns) {
<mat-card appearance="outlined" class="card-content" [class.lg]="displayedColumns.length > 7">
  <div class="toolbar">
    <h2>{{ tableName }}</h2>
    <ng-content></ng-content>
  </div>
  <div #table>
    <table mat-table [dataSource]="data" [class.footer-visible]="!data.filteredData.length">
      <!-- <ng-content></ng-content> -->
      <!-- Crew Number Column -->
      @for (column of columns; track column; let index = $index) {
      <ng-container [matColumnDef]="column.id" class="mat-column">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="column.textAlign">
          @if (column.transKey) {
            {{ column.transKey | translate }}
          }
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container
            [ngTemplateOutlet]="columnSection"
            [ngTemplateOutletContext]="{
              $implicit: column,
              element: element
            }"
          >
          </ng-container>
        </td>
        <td mat-footer-cell 
          *matFooterCellDef 
          [attr.colspan]="displayedColumns.length"
          [class]="index === 0 ? 'no-data-footer' : 'hidden-footer'">
          {{ 'TableContainsNoData' | translate }}
        </td>
      </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>

    <!-- @if (data.filteredData.length) {
      <mat-divider></mat-divider>
      <div class="footer">
        Show footer data
      </div>
    } -->

  </div>
</mat-card>
}

<ng-template #columnSection let-columnContent let-element="element">
  <div class="table-row" [class.multi]="columnContent.type === 'multi' || (!element[columnContent.id] && columnContent.type === 'editable')">
    @if (((displayedColumns.length > 7 ? ['xs', 'sm', 'md', 'lg'] : ['xs', 'sm', 'md']) | breakpoint | async) && columnContent.transKey) {
      <div class="header">{{ columnContent.transKey | translate }}</div>
    }
    @if (columnContent.type === 'image') {
      <div class="smaller">
        <img
          src="{{ '../../../../../../assets/' + element[columnContent.id] }}"
          alt="image"
          class="flag"
        />
      </div>
    } @else if (columnContent.type === 'date') {
      <div class="smaller">
        @if (columnContent.dateFormat) {
          {{ element[columnContent.id] | date: columnContent.dateFormat }}
        } @else {
          {{ element[columnContent.id] | date }}
        }
      </div>
    } @else if (columnContent.type === 'button') {
      <button
        mat-icon-button
        [matTooltip]="columnContent.tooltip ? (columnContent.tooltip | translate) : ''"
        (click)="onClickButton(columnContent.id, element)"
      >
        <mat-icon>{{ columnContent.icon }}</mat-icon>
      </button>
    } @else if (columnContent.type === 'link') {
      <div
        class="smaller"
        [class.plain]="element[columnContent.id] === null || element[columnContent.id] == undefined"
        [class.link]="evaluateValue(element[columnContent.id])"
        [matTooltip]="evaluateValue(element[columnContent.id]) ? ('OpenForDetails' | translate) : ''"
        (click)="onClickButton(columnContent.id, element)"
      >
        @if (evaluateArray(element[columnContent.id]) && element[columnContent.id].length) {
          {{ element[columnContent.id].length }}
        } @else {
          {{ evaluateValue(element[columnContent.id]) ? element[columnContent.id] : "-" }}
        }
      </div>
    } @else if (columnContent.type === 'editable') {
      @if (element[columnContent.id]) {
        <div
          class="smaller"
          [class.link]="element[columnContent.id]"
          [matTooltip]="'OpenForDetails' | translate"
          (click)="onClickButton(columnContent.id, element)"
        >
          {{ element[columnContent.id] }}
        </div>
      } @else {
        <button
          class="multi"
          mat-icon-button
          [matTooltip]="'Add' | translate"
          (click)="onClickButton(columnContent.id, element)"
        >
          <mat-icon>add</mat-icon>
        </button>
      }
    } @else if (columnContent.type === 'boolean') {
      <mat-icon>{{ element[columnContent.id] ? 'check_box' : 'disabled_by_default' }}</mat-icon>
    } @else if (columnContent.type === 'multi' && columnContent.columns.length) {
      @for (subColumn of columnContent.columns; track subColumn) {
        <ng-container
          [ngTemplateOutlet]="columnSection"
          [ngTemplateOutletContext]="{
            $implicit: subColumn,
            element: element
          }"
        >
        </ng-container>
      } 
    } @else {
      <div 
        class="smaller"
        [class.cross]="columnContent.type === 'cross' && evaluateCrossValue(columnContent.id, element['crossed'])"
      >
        {{ evaluateValue(element[columnContent.id]) ? element[columnContent.id] : "-" }}
      </div>
    }
  </div>
</ng-template>
